import type { FaireProductEntity } from "../../entity_types/product";

export const p_upnb4k95qc: FaireProductEntity = {
  token: "p_upnb4k95qc",
  type: "product",
  name: "Single Deck Playing Cards - Dogs",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/cafe00756dcc6cec2617ae580e118f64fa0045d127eb3a24a26b34d8d7c56e31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b02ac2558aab3363edf365d25344491c8b466574009929e2b73aa8320e976b8f.jpeg",
    "https://cdn.faire.com/fastly/b2dec631451bad6108dd9e8efb077bbd85da038005fb1cc7278a59e5ba5a76ad.jpeg",
  ],
  priceDollars: 8,
  description:
    'Bring a playful sense of movement to card games with the Dogs Playing Cards, designed by Roomytown in their studio in Bath, UK. This single deck includes 52 standard cards plus 2 jokers, each featuring paper cut-out style dog illustrations inspired by the whimsical animal collages of artist Philipp Otto Runge from the late 1700s. Full of energy and character, the artwork captures dogs mid-leap, stretch, and play, bringing a lively charm to every hand dealt.\n\nThe reverse of each card features a deep blue striped pattern inspired by vintage printed papers, adding a nostalgic decorative detail to the deck. Presented in a premium pull-drawer box with gold foil accents, these playing cards make a charming gift for dog lovers, design enthusiasts, and anyone drawn to playful vintage-inspired artwork. Ideal for family games, hosting, or displaying on a coffee table, they bring a little humour and character to everyday moments.\n\nSize: H 104mm x W 76.2mm x D 30.4mm / H 4.1" x W 3.0" x D 1.2"',
  tags: [],
  msrpDollars: 17.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:41.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
